// extracted by mini-css-extract-plugin
export default {"proceedButton":"styles_proceedButton__mIpVv","stacked":"styles_stacked__aFeKF","disabled":"styles_disabled__-IW5E"};